export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13459.b9a21671.jpg";